import classNames from "classnames";
import { LowOpacityButton } from "@alchemy/ui";
import { Discord, MessageChat01, Star02 } from "@alchemy/ui/icons/16";

import useLDFeatureFlag from "@features/launchdarkly/useLDFeatureFlag";
import { FeatureFlagKey } from "@features/launchdarkly/featureFlag";
import useTeamSupportUrl from "../../../react-query/queries/useTeamSupportUrl";
import { useState } from "react";
import FeedbackModal from "./FeedbackModal";

interface NavFooterProps {
  onHideOverlay?: () => void;
  onHover?: () => void;
}

const NavFooter = ({ onHideOverlay, onHover }: NavFooterProps) => {
  const { data: enableNavRedesign } = useLDFeatureFlag(
    FeatureFlagKey.NavRedesign,
  );

  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const teamSupport = useTeamSupportUrl();

  const supportButtonLabel = teamSupport.data?.isVip
    ? "VIP Support"
    : "Discord Support";
  const feedbackButtonLabel = enableNavRedesign ? "Share feedback" : "Feedback";
  const ButtonIcon = teamSupport.data?.isVip ? MessageChat01 : Discord;

  return (
    <footer
      className={classNames(
        "relative z-20 flex flex-col gap-2 px-4 pb-5 pt-1 transition",
        teamSupport.data ? "" : "opacity-0",
      )}
    >
      <LowOpacityButton
        icon={<Star02 />}
        className="flex w-full justify-center overflow-hidden whitespace-nowrap"
        onClick={() => setIsFeedbackModalOpen(true)}
        onMouseEnter={onHover}
      >
        {feedbackButtonLabel}
      </LowOpacityButton>

      {enableNavRedesign ? null : (
        <LowOpacityButton
          as="a"
          target="_blank"
          href={teamSupport.data?.url}
          icon={<ButtonIcon />}
          className="flex w-full justify-center overflow-hidden whitespace-nowrap"
          onClick={onHideOverlay}
          onMouseEnter={onHover}
        >
          {supportButtonLabel}
        </LowOpacityButton>
      )}

      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
      />
    </footer>
  );
};

export default NavFooter;
